import { MESSAGE_STATUS } from "../../utils/constants";
import {
  CREATE_CONVERSATION_FAILURE,
  CREATE_CONVERSATION_REQUEST,
  CREATE_CONVERSATION_SUCCESS,
  DELETE_CONVERSATION,
  FETCH_CONVERSATIONS_FAILURE,
  FETCH_CONVERSATIONS_REQUEST,
  FETCH_CONVERSATIONS_SUCCESS,
  FETCH_FILTERED_CONVERSATIONS_FAILURE,
  FETCH_FILTERED_CONVERSATIONS_REQUEST,
  FETCH_FILTERED_CONVERSATIONS_SUCCESS,
  RESET_CONVERSATION,
  SEARCH_CONVERSATIONS_FAILURE,
  SEARCH_CONVERSATIONS_REQUEST,
  SEARCH_CONVERSATIONS_SUCCESS,
  SET_CONVERSATION,
  SET_MESSAGES,
  SYSTEM_SEND_MESSAGE,
  UPDATE_CONVERSATION_TITLE,
  UPDATE_MESSAGE_CONTENT,
  USER_SEND_MESSAGE,
  SET_MESSAGE_LOADING,
  SET_STREAMING_MESSAGE_ID,
  UPDATE_MESSAGE_SOURCES,
  UPDATE_MESSAGE_TOOLS,
  ADD_TOOL_EXECUTION,
  SET_MESSAGE_ERROR,
  SET_PENDING_FILES,
  CLEAR_PENDING_FILES,
  UPDATE_MESSAGE_NODE_EXECUTION,
  UPDATE_MESSAGE_PLAN,
  UPDATE_MESSAGE_STEP_EXECUTION,
  UPDATE_MESSAGE_METADATA,
  UPDATE_MESSAGE_ARTIFACTS,
  UPDATE_MESSAGE_LIKE,
  SET_DOCUMENT_PROCESSING_STATUS,
  CLEAR_DOCUMENT_PROCESSING_STATUS,
} from "../actions/types";

const initialState = {
  conversations: [],
  messages: [],
  conversation: null,
  loading: false,
  loadingCreate: false,
  loadingMessage: false,
  streamingMessageId: null,
  pendingFiles: [],
  documentProcessingStatus: [],
  error: null,
};

const conversationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CONVERSATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_CONVERSATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        conversations: action.payload.isLoadMore
          ? [...state.conversations, ...action.payload.data]
          : action.payload.data,
      };
    case FETCH_CONVERSATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case SEARCH_CONVERSATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SEARCH_CONVERSATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        conversations: action.payload,
      };
    case SEARCH_CONVERSATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CREATE_CONVERSATION_REQUEST:
      return {
        ...state,
        loadingCreate: true,
        error: null, // Clear any previous error
      };

    case CREATE_CONVERSATION_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        conversations: [action.payload, ...state.conversations], // Prepend new conversation to show first
        error: null, // Clear any previous error
      };

    case CREATE_CONVERSATION_FAILURE:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload, // Set error message
      };

    case DELETE_CONVERSATION:
      return {
        ...state,
        conversations: state.conversations.filter(
          (t) => !action.payload.includes(t.id)
        ),
      };

    case UPDATE_CONVERSATION_TITLE:
      return {
        ...state,
        conversations: state.conversations.map((conv) =>
          conv.id === action.payload.conversationId
            ? { ...conv, title: action.payload.title }
            : conv
        ),
        conversation:
          state.conversation?.id === action.payload.conversationId
            ? { ...state.conversation, title: action.payload.title }
            : state.conversation,
      };

    case SET_CONVERSATION:
      return {
        ...state,
        conversation: action.payload,
      };

    case SET_MESSAGES:
      return {
        ...state,
        messages: action.payload,
      };
    // case SET_MESSAGES:
    //   return {
    //     ...state,
    //     messages: action.payload.map((message) => ({
    //       ...message,
    //       content: message.content.replace(/\n/g, "<br/>"),
    //     })),
    //   };

    case UPDATE_MESSAGE_CONTENT:
      return {
        ...state,
        messages: state.messages.map((message) =>
          message.id === action.payload.messageId
            ? { ...message, content: action.payload.content }
            : message
        ),
      };

    case USER_SEND_MESSAGE:

      return {
        ...state,
        messages: [
          ...state.messages,
          {
            id: Math.random().toString(),
            content: action.payload.replace(/\n/g, "<br/>"),
            role: "USER",
            status: MESSAGE_STATUS.PENDING,
            created_at: new Date(),
          },
        ],
      };

    case SYSTEM_SEND_MESSAGE:
      const updatedMessages = state.messages.map((msg) =>
        msg.id === action.payload.id ? { ...msg, ...action.payload } : msg
      );
      return {
        ...state,
        messages: updatedMessages,
      };

    case RESET_CONVERSATION:
      return initialState



    case FETCH_FILTERED_CONVERSATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_FILTERED_CONVERSATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        conversations: action.payload,
      };

    case FETCH_FILTERED_CONVERSATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SET_MESSAGE_LOADING:
      return {
        ...state,
        loadingMessage: action.payload,
      };

    case SET_STREAMING_MESSAGE_ID:
      return {
        ...state,
        streamingMessageId: action.payload,
      };

    case UPDATE_MESSAGE_SOURCES:
      return {
        ...state,
        messages: state.messages.map((message) =>
          message.id === action.payload.messageId
            ? { ...message, sources: action.payload.sources }
            : message
        ),
      };

    case UPDATE_MESSAGE_TOOLS:
      return {
        ...state,
        messages: state.messages.map((message) =>
          message.id === action.payload.messageId
            ? {
                ...message,
                // Only update fields that are actually provided (not undefined)
                ...(action.payload.tool_executions !== undefined && { tool_executions: action.payload.tool_executions }),
                ...(action.payload.activeTools !== undefined && { activeTools: action.payload.activeTools }),
                ...(action.payload.completedTools !== undefined && { completedTools: action.payload.completedTools }),
                ...(action.payload.workflowProgress !== undefined && { workflowProgress: action.payload.workflowProgress }),
                ...(action.payload.currentThought !== undefined && { currentThought: action.payload.currentThought }),
              }
            : message
        ),
      };

    case ADD_TOOL_EXECUTION:
      return {
        ...state,
        messages: state.messages.map((message) =>
          message.id === action.payload.messageId
            ? {
                ...message,
                tool_executions: [
                  ...(message.tool_executions || []),
                  action.payload.toolExecution,
                ],
              }
            : message
        ),
      };

    case SET_MESSAGE_ERROR:
      return {
        ...state,
        loadingMessage: false,
        messages: state.messages.map((message) =>
          message.id === action.payload.messageId
            ? { ...message, error: true, status: MESSAGE_STATUS.ERROR }
            : message
        ),
      };

    case SET_PENDING_FILES:
      return {
        ...state,
        pendingFiles: action.payload,
      };

    case CLEAR_PENDING_FILES:
      return {
        ...state,
        pendingFiles: [],
      };

    case UPDATE_MESSAGE_NODE_EXECUTION:
      return {
        ...state,
        messages: state.messages.map((message) =>
          message.id === action.payload.messageId
            ? { ...message, node_executions: action.payload.node_executions }
            : message
        ),
      };

    case UPDATE_MESSAGE_PLAN:
      return {
        ...state,
        messages: state.messages.map((message) =>
          message.id === action.payload.messageId
            ? { ...message, execution_plan: action.payload.execution_plan }
            : message
        ),
      };

    case UPDATE_MESSAGE_STEP_EXECUTION:
      return {
        ...state,
        messages: state.messages.map((message) =>
          message.id === action.payload.messageId
            ? {
                ...message,
                execution_plan: message.execution_plan
                  ? {
                      ...message.execution_plan,
                      steps: message.execution_plan.steps.map((step) =>
                        step.step_id === action.payload.step_id
                          ? { ...step, ...action.payload.updates }
                          : step
                      ),
                    }
                  : message.execution_plan,
              }
            : message
        ),
      };

    case UPDATE_MESSAGE_METADATA:
      return {
        ...state,
        messages: state.messages.map((message) =>
          message.id === action.payload.messageId
            ? { ...message, metadata: action.payload.metadata }
            : message
        ),
      };

    case UPDATE_MESSAGE_ARTIFACTS:
      return {
        ...state,
        messages: state.messages.map((message) =>
          message.id === action.payload.messageId
            ? { ...message, artifacts: action.payload.artifacts }
            : message
        ),
      };

    case UPDATE_MESSAGE_LIKE:
      return {
        ...state,
        messages: state.messages.map((message) =>
          message.id === action.payload.message_id
            ? { ...message, like: action.payload.value }
            : message
        ),
      };

    case SET_DOCUMENT_PROCESSING_STATUS:
      return {
        ...state,
        documentProcessingStatus: action.payload,
      };

    case CLEAR_DOCUMENT_PROCESSING_STATUS:
      return {
        ...state,
        documentProcessingStatus: [],
      };

    default:
      return state;
  }
};

export default conversationReducer;
